(function() {
	'use strict';

	/**
	 * Repository for the user's wine db.
	 */

	angular
		.module("pwc.repositories")
		.service("WineRepository", WineRepository);

	WineRepository.$inject = ['$window', 'lodash', '$log', 'Wine', 'userPouch', '$q', 'Region'];

	function WineRepository($window, lodash, $log, Wine, userPouch, $q, Region){

		/**
		 * Begin methods
		 */

		function get(id){
			return userPouch.db().get(id);
		}

		function getCustomFieldLabels(){
			return userPouch.db().query('custom_field_index').then(function(result){
				$log.debug('Custom field result', result);
				return lodash.uniq(lodash.map(result.rows, 'key'));
			}).catch(function(err){
				// design doc probably doesn't exist, create it
				$log.warn('Custom field index does not yet exist. Creating...');
                $log.debug(err.message);

				return userPouch.createCustomFieldIndex().then(function(result){
                    return lodash.uniq(lodash.map(result.rows, 'key'));
				});
			});
		}

		function fetchAll(){
			return userPouch.db().allDocs({
				conflicts: true,
				include_docs: true
			}).then(function(response){

				$log.debug('All wine docs', response);

				if (response.rows.length === 0){
					return $q.reject('No local docs yet.');
				}

				// need to cleanup conflicts
				var conflictsToBatchDelete = [];

				lodash.each(response.rows, function(row) {
					if (row.doc._conflicts && row.doc._conflicts.length){

						var conflict = {
							"_id": row.doc._id,
							"_rev": row.doc._rev,
							"_deleted": true
						};

						conflictsToBatchDelete.push(conflict);
					}
				});

				if (conflictsToBatchDelete.length){
					$log.debug('Batch deleting ' + conflictsToBatchDelete.length + ' docs...', conflictsToBatchDelete);
					return userPouch.db().bulkDocs(conflictsToBatchDelete)
						.catch(function (err) {
							$log.debug('Error doing bulk update', err);
						})
						.then(function(){
							return response;
						});
				}

				return response;

			}).catch(function(err){
				$log.debug('Error fetching all docs', err);
				return $q.reject();
			});
		}

		function hydrateArray(docs){

			$log.debug('Hydrating array...', docs.length);

			// remove design docs first.
			docs = lodash.reject(docs, function(n){
				return lodash.startsWith(n._id, '_design');
			});

			var wineEntities = lodash.map(docs, function(e) {
				// remove conflicts and add to result
				var data = lodash.omit(e, ['_conflicts']);
				return new Wine(data);
			});

			return $q.when(wineEntities);
		}

		function hydrateAll(response){

			$log.debug('Hydrating all...', response.rows.length);

			var wines = lodash.pluck(response.rows, 'doc');

			return hydrateArray(wines);
		}

		function all(){

			return fetchAll().then(hydrateAll);
		}

		/**
		 * @param wineEntities
		 * @returns {*|number}
		 */
		function getTotalCellarBottleCount(wineEntities) {
			return lodash.sum(wineEntities, function(wine) {
				return wine.cellar.qty;
			});
		}

		/**
		 * getCellarValue
		 *
		 * given a collections of wineEntities return float
		 *
		 * @param wineEntities
		 * @returns {*|number}
		 *
		 */
		function getCellarValue(wineEntities) {
			return lodash.sum(wineEntities, function(wine) {
				var value = (wine.cellar && wine.cellar.value) ? parseFloat(wine.cellar.value) : 0;
				return (value > 0) ? value * wine.cellar.qty : 0;
			});
		}


		/**
		 *
		 * @param wineEntities
         * @returns moment
         */
		function findFirstWineAcquisitionDate(wineEntities) {
			// now. every acq will be older than now.
			var firstWineAcquisitionDate = moment();

			// rip through each
			lodash.forEach(wineEntities, function(wine) {
				// get acquisitions
				var acqusitions = wine.getAcquisitionHistory();

				// if we have any
				if (acqusitions) {
					// the earliest is first
					if (acqusitions[0].date) {
						var firstAcqusition = moment(acqusitions[0].date);

						// if the current
						if (firstAcqusition <= firstWineAcquisitionDate) {
							firstWineAcquisitionDate = firstAcqusition;
						}
					}
				}
			});

			return firstWineAcquisitionDate;
		}

		function isEmptyOrNull(val){
			return ! angular.isDefined(val) || val === '' || lodash.isNull(val);
		}

		function save(wine){

			if (! isEmptyOrNull(wine.vintage) && wine.vintage != 'NV'){
				wine.vintage = parseInt(wine.vintage);
			}

			if (wine.cellar && ! isEmptyOrNull(wine.cellar.qty)){
				wine.cellar.qty = parseInt(wine.cellar.qty);
			} else {
				wine.cellar.qty = 0;
			}

			return userPouch.save(wine);
		}

		function markAllOnOrderAsArrived(wine){
			wine.cellar.history.forEach(function(history){
				if (history.type === "purchase" && history.status == "On Order"){
					history.status = "Arrived";
					history.arrived = $window.moment();

					wine.cellar.qty = parseInt(wine.cellar.qty) + parseInt(history.qty);
				}
			});

			wine.cellar.ordered = false;

			return save(wine);
		}

		/**
		 * Generates
		 */
		function generateNumericId(){
			var yearMonth = $window.moment().format('YYMM');

			// setup default
			var number = 1;

			return userPouch.db().allDocs({
				include_docs: true
			}).then(function(response) {

				if (response.rows.length > 0) {
					// we have results, let's see if we have some with ids that start on this date
					var wines = lodash.pluck(response.rows, 'doc');

					var matchingDates = lodash.filter(wines, function(obj) {
						var cellarId = lodash.get(obj, 'cellar.id', null);
						return cellarId && lodash.startsWith(cellarId, yearMonth);
					});

					if (matchingDates.length > 0){
						var ids = lodash.pluck(matchingDates, 'cellar.id');

						var max = lodash.max(ids);

						// remove the first date part and increment

						var maxId = max.toString().substr(4) || 0;

						number = lodash.parseInt(maxId) + 1;
					}
				}

				// format will be YYMMXXX(X) where X is an incremented number
				var id = lodash.padLeft(number, 3, '0');

				return yearMonth + id;
			});
		}

		/**
		 * Generates a barcode from an ID. We want to generate 11 digit because the barcode software will calculate
		 * the proper check digit in the 12 slot.
		 */
		function generateBarcode(id){
			var barcodePrefix = '7';

			return barcodePrefix + lodash.padRight(id, 10, '0');
		}

		function uniqueAcquisitionSources(){
			// @TODO create a view for this
			return all().then(function(wineEntities){
				var sources = [];

				if (wineEntities.length > 0) {

					// add only those in the cellar
					lodash.forEach(wineEntities, function (wine) {
						if (wine.cellar.history.length > 0) {
							lodash.forEach(wine.cellar.history, function(history){
								if (lodash.get(history, 'type') === 'purchase' && lodash.isNotEmptyOrNull(history.source)){
									sources.push(history.source);
								}
							});
						}
					});

				}

				return lodash.uniq(sources).sort();
			});
		}

        function _fetchProducerNames(){
            return userPouch.db().query('producer_name_index').then(function(result){
                return _sortArr(lodash.uniq(lodash.map(result.rows, 'key')));
            });
        }

		function uniqueProducers(){
            return _fetchProducerNames()
                .catch(function(err){
                    $log.warn('Error loading producer names.', err);

                    if (err.status === 404){
                        return _createProducerNameIndex().then(_fetchProducerNames);
                    }

                    return [];
                });
		}

		function uniqueRegions(){
			// @TODO create a view for this
			return all().then(function(wineEntities){
				var regions = [];

				if (wineEntities.length > 0) {

					lodash.forEach(wineEntities, function (wine) {

						var isInternal = lodash.get(wine, 'region._id');

						var regionName = lodash.trim(lodash.get(wine, 'region.name'));

						if (! isInternal && ! lodash.isEmptyOrNull(regionName) && ! lodash.includes(regions, regionName)){
							regions.push(regionName);
						}
					});

					return lodash.map(regions.sort(), function(val){
						return new Region({
							"name": val
						});
					});
				}

				return regions;

			}).catch(function(err){
				$log.error(err);
				return [];
			});
		}

		function _fetchWineNames(){
            return userPouch.db().query('wine_name_index').then(function(result){
                return _sortArr(lodash.map(result.rows, 'value'));
            });
		}

		function uniqueWineNames(){

            return _fetchWineNames()
				.catch(function(err){
					$log.warn('Error loading wine names.', err);

					if (err.status === 404){
						return _createWineNameIndex().then(_fetchWineNames);
					}

					return [];
				});
		}

        function uniqueVarietals(){
            // @TODO create a view for this
            return all().then(function(wineEntities){
                var result = [];

                if (wineEntities.length > 0) {

                    lodash.forEach(wineEntities, function (wine) {
                        var name = lodash.get(wine, 'varietal.name');

                        if (! lodash.isEmptyOrNull(name) && ! lodash.includes(result, name)){
                            result.push(name);
                        }
                    });

                    return _sortArr(result);
                }

                return result;

            }).catch(function(err){
                $log.error(err);
                return [];
            });
        }

        function _sortArr(arr){
        	return arr.sort(function (a, b) {
                return a.toLowerCase().localeCompare(b.toLowerCase());
            });
		}

        /**
         * @private
         * @return Promise
         */
        function _createProducerNameIndex(){
            var mapFunction = function(doc) {
                if (doc.producer && doc.producer.name){
                    emit(doc.producer.name);
                }
            };

            return _createIndex('producer_name', mapFunction);
        }

        /**
         * @private
		 * @return Promise
         */
		function _createWineNameIndex(){
            var mapFunction = function(doc) {
                if (doc.name && doc.name.length > 0){
                    emit(doc._id, doc.name);
                }
            };

            return _createIndex('wine_name', mapFunction);
		}

		function _createIndex(name, mapFunction){

			name = name + '_index';

            var doc = {
                _id: '_design/' + name,
                views: {}
            };

            doc.views[name] = {
            	"map": mapFunction.toString()
            };

            return userPouch.db().put(doc).then(function() {
                $log.debug('Design doc created:', doc);
                // kick off an initial build, return immediately
                return userPouch.db().query(name, { stale: 'update_after' });
            }).catch(function(err){
                $log.info('Design doc already exists:', name);
            });
		}

		// exposed, public API
		return {
			get: get,
			markAllOnOrderAsArrived: markAllOnOrderAsArrived,
			save: save,
			getTotalCellarBottleCount: getTotalCellarBottleCount,
			getCellarValue: getCellarValue,
			findFirstWineAcquisitionDate: findFirstWineAcquisitionDate,
			all: all,
			fetchAll: fetchAll,
			hydrateArray: hydrateArray,
			hydrate: hydrateAll,
			generateBarcode: generateBarcode,
			generateNumericId: generateNumericId,
			uniqueAcquisitionSources: uniqueAcquisitionSources,
			uniqueProducers: uniqueProducers,
			uniqueRegions: uniqueRegions,
			uniqueWineNames: uniqueWineNames,
            uniqueVarietals: uniqueVarietals,
			getCustomFieldLabels: getCustomFieldLabels
		};

	}

})();
